import React from "react";
import ReactDom from "react-dom";

import {extendObservable, observable, action, computed, when, autorun} from 'mobx';
import {observer, inject} from 'mobx-react';

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseComponent from 'base-component';
import BaseViewStore from 'base-viewstore';
import BaseContentModel from 'base-contentmodel';

import deepExtend from 'deep-extend';
import {Mixin, mix} from 'mixwith';
import {ViewControllerMixin} from 'layout-component';

export class DeloitteAuthViewStore extends mix(BaseViewStore).with(ViewControllerMixin){
  constructor(){
    super(...arguments);
    const {
      contentModel, 
      dataModel: {
        domainStore: projectDomainStore
      },
      currentView: {
        route
      },
      modalViewStore
    } = this.props;

    //just in case we're already signed in :-)
    let self = this;
    projectDomainStore.refreshContext = action.bound((cb, errCb) => {

      if(!projectDomainStore.simgate) throw new Error("missing simgate")
      projectDomainStore.isRefreshing = true;
      const callback = action("getContext-callback", res => {
        if(projectDomainStore.contextIsLoaded && res.context.pathID === 0) throw new Error('{"IsError":true,"ErrorMessage":"Access denied. Lost simgate context!"}');
  
        const {
          userId,
          roleId,
        } = res.context;

        if(roleId > 0) {
          if(roleId == 1) {
            // handle a super admin specially
            if((window.location.href.indexOf("authoring") < 0 && window.location.href.indexOf("localhost") < 0) || window.location.href.indexOf("participant") >= 0) {
              window.location.href = window.location.origin + "/dashboard";
              return;
            }
          }
          else if(roleId != 2) { 
            window.location.href = window.location.origin + "/dashboard";
            return;
          }

          if(roleId == 2) {
            // get the team and session information
            projectDomainStore.simgate.execQuery({ 
              query: "custom-queries://getContextData", 
              parameters: {userId: userId} 
            }).then( (result) => {
              
              res.context.team = {
                id: result.data[0][0].PathID,
                pathId: result.data[0][0].PathID,
                pathType: result.data[0][0].PathType,
                parentId: result.data[0][0].ParentID,
                attr1: result.data[0][0].Attr1,
                attr2: result.data[0][0].Attr2,
                attr3: result.data[0][0].Attr3,
                attr4: result.data[0][0].Attr4,
                attr5: result.data[0][0].Attr5,
                num1: result.data[0][0].Num1,
                num2: result.data[0][0].Num2,
                num3: result.data[0][0].Num3,
                num4: result.data[0][0].Num4,
                num5: result.data[0][0].Num5,
              };
              res.context.user.pathId = result.data[0][0].UserTeamID;
              res.context.sessionName = result.data[0][0].SessionName;
              
              projectDomainStore.pathId = res.context.user.pathId;
              projectDomainStore.currentRoundNo = res.context.team.num5 || 1;
              projectDomainStore.teamStateName = res.context.team.attr4;
              projectDomainStore.context.simParentPathId = res.context.team.parentId;

              deepExtend( projectDomainStore.context, res.context );
          
              projectDomainStore.isRefreshing = false;
              projectDomainStore.hasRefreshed = +new Date;
              projectDomainStore.contextIsLoaded = true;
        
              if(typeof cb === "function") cb(); 
              
            }).catch(errCb);
          }
          else {
            projectDomainStore.pathId = 1;
            projectDomainStore.currentRoundNo = 0;
            projectDomainStore.teamStateName = "";
            projectDomainStore.context.simParentPathId = 3;

            deepExtend( projectDomainStore.context, res.context );
        
            projectDomainStore.isRefreshing = false;
            projectDomainStore.hasRefreshed = +new Date;
            projectDomainStore.contextIsLoaded = true;
          }
        }
        else {
          projectDomainStore.pathId = 0;
          projectDomainStore.currentRoundNo = 0;
          projectDomainStore.teamStateName = null;
          projectDomainStore.context.simParentPathId = 3;

          deepExtend( projectDomainStore.context, res.context );
      
          projectDomainStore.isRefreshing = false;
          projectDomainStore.hasRefreshed = +new Date;
          projectDomainStore.contextIsLoaded = true;
    
          if(typeof cb === "function") cb(); 
        }

      });
  
      const taskArgs = [
        projectDomainStore.simgate.getContext,
        {},
        {
          onSuccess: callback,
          onFailure: errCb
        }
      ]
      if(projectDomainStore.simgate.runTask){
        projectDomainStore.simgate.runTask(...taskArgs)
      }else if(projectDomainStore.simgate.AsyncTask){
        const asyncTask = new projectDomainStore.simgate.AsyncTask();     
        asyncTask.runTask(...taskArgs);
      }else{
        projectDomainStore.simgate.getContext( taskArgs[1] ).then( callback ).catch( errCb )
      }
  
      return projectDomainStore;
    })

    projectDomainStore.refreshContext();

    // set up condition for this auth strategy being "done""
    when(
      () => projectDomainStore.context.simParentPathId > 0 //we have user's future team paths' parent path
        && projectDomainStore.context.user.roleID
        && route.roles.some( r => r.roleId === projectDomainStore.context.user.roleID ), //user context reflects they are allowed in to this route
      () => {
        projectDomainStore.signOut = action( () => {
          const dirtyEntities = contentModel.$parent.entities.values().filter( ent => ent.isDirty );
          modalViewStore.setModal({
            title: "Would you like to log out?",
            message: dirtyEntities.length ? "You will lose "+dirtyEntities.length+" unsaved changes." : "",
            confirmLabel: 'Logout',
            confirmBtnClass: 'green check-a',
            cancelLabel: 'Cancel',
            cancelBtnClass: 'red times-b',
            onConfirmFunc: () => projectDomainStore._signOut( () => window.location.reload() )
          })
        } )
        contentModel.done = true
      }
    )
  } 

  @observable.ref role = null
  @observable claim = {
    firstName: "",
    lastName: "",
    loginName: "",
    password: "",
    passwordConfirm: "",
    demographic1: 0,
    demographic2: 0,
    demographic3: 0,
    demographic4: 0,
    demographic5: 0,
    authCode: "regis123"
  }
  @computed get viewMap(){
    return {
      "signup": {
        id: "signup",
        Component: DeloitteSignUp,
        contentModel: this.props.contentModel
      },
      "chooseSession": {
        id: "chooseSession",
        Component: DeloitteChooseSession,
        contentModel: this.props.contentModel
      }
    }
  }
  @computed get invalidSignUp(){
    const invalid = {}
    const {
      contentModel: {
        authCode
      }
    } = this.props;

    if(!this.claim.firstName) invalid.firstName = "*Please enter your first name";
    if(!this.claim.lastName) invalid.lastName = "*Please enter your last name";
    if(!this.claim.loginName) invalid.email = "*Please enter email";
    if(!this.claim.password) invalid.password = "*Please enter password";
    if(!this.claim.passwordConfirm) invalid.passwordConfirm = "*Please confirm password";
    if(this.claim.password && this.claim.passwordConfirm && this.claim.password != this.claim.passwordConfirm) invalid.passwordConfirm = "*Password and password confirm must match";
    // @TODO use encryption to make this worth something
    if(this.claim.authCode !== authCode ) invalid.authCode = "*Invalid auth code";
    return invalid;
  }
  @computed get invalidSignIn(){
    const {dataModel: {domainStore}} = this.props;
    const {
      currentView: {
        route: {
          roles
        }
      },
      contentModel: {
        authCode
      }
    } = this.props;

    const invalid = {}

    if(!this.claim.loginName) invalid.email = "*Please enter email";
    if(!this.claim.password) invalid.password = "*Please enter password";
    if( domainStore.context.user.roleID && !roles.some( r => r.roleId === domainStore.context.user.roleID ) ) 
      invalid.notAuthorized = "Not authorized.";
    return invalid;
  }
  @observable warning = ""
  @action.bound handleSignIn(e){
    e && e.preventDefault && e.preventDefault();
    const {dataModel: {domainStore}} = this.props;
    const errCb = (err) => {err && (this.warning = err.message)};
    
    try {
      let self = this;
      if(!domainStore.simgate) throw new Error("missing simgate")
      const signOutCb = () => { 
        domainStore.simgate.signIn( self.claim )
          .then( res => {
            if(!res || !res.context) throw new Error("Access denied.");

            const {
              userId,
              roleId,
            } = res.context;

            if(roleId == 1) {
              // handle a super admin specially
              if((window.location.href.indexOf("authoring") < 0 && window.location.href.indexOf("localhost") < 0) || window.location.href.indexOf("participant") >= 0) {
                window.location.href = window.location.origin + "/dashboard";
                return;
              }
            }
            else if(roleId != 2) { 
              window.location.href = window.location.origin + "/dashboard";
              return;
            }
            
            if(roleId == 2) {

              // get the team and session information
              domainStore.simgate.execQuery({ 
                query: "custom-queries://getContextData", 
                parameters: {userId: userId} 
              }).then( (result) => {
                
                res.context.team = {
                  id: result.data[0][0].PathID,
                  pathId: result.data[0][0].PathID,
                  pathType: result.data[0][0].PathType,
                  parentId: result.data[0][0].ParentID,
                  attr1: result.data[0][0].Attr1,
                  attr2: result.data[0][0].Attr2,
                  attr3: result.data[0][0].Attr3,
                  attr4: result.data[0][0].Attr4,
                  attr5: result.data[0][0].Attr5,
                  num1: result.data[0][0].Num1,
                  num2: result.data[0][0].Num2,
                  num3: result.data[0][0].Num3,
                  num4: result.data[0][0].Num4,
                  num5: result.data[0][0].Num5,
                };
                res.context.user.pathId = result.data[0][0].UserTeamID;
                res.context.sessionName = result.data[0][0].SessionName;
              
                deepExtend( domainStore.context, res.context );
    
                domainStore.contextIsLoaded = true;
                if(typeof cb === "function") cb();   
                
              }).catch(errCb);   
            }
            else {
              deepExtend( domainStore.context, res.context );
  
              domainStore.contextIsLoaded = true;
              if(typeof cb === "function") cb(); 
            }      
          })
          .catch( errCb ) 
      }

      domainStore.simgate.signOut().then(signOutCb).catch(signOutCb)

      domainStore.signIn( this.claim, null, errCb )
    }
    catch(err) {
      errCb(err);
    }
  }
  @action.bound handleSignUp(e){
    e.preventDefault();
    const {
      dataModel: {
        domainStore
      },
      contentModel: {
        allowSignupFor,
        authCode
      }
    } = this.props;

    domainStore.createUser( { 
      roleID: allowSignupFor.roleId, 
      firstName: this.claim.firstName,
      lastName: this.claim.lastName,
      email: this.claim.loginName,
      loginName: this.claim.loginName,
      password: this.claim.password,
      authCode: this.claim.authCode,

    }, () => this.handleSignIn() )
  }
  @action.bound updateClaim(which, val){
    this.claim[which] = val;
  }
}

@editable
@inject("dataModel")
@inject("modalViewStore")
@observer
@autoclass
export class DeloitteSignIn extends BaseComponent{
  static ViewStore = DeloitteAuthViewStore;
  render(){
    const { 
      dataModel: {
        domainStore
      },
      contentModel: authContentModel
    } = this.props;

    const { 
      title, 
      headerMessage, 
      welcomeMessage,
      allowSignupFor
    } = authContentModel;

    const {
      SelectedView, 
      clearView, 
      selectView, 
      handleSignIn, 
      invalidSignIn: invalid,
      claim,
      updateClaim,
      warning
    } = this.viewStore; 

    if(invalid.notAuthorized){
      return <div>{invalid.notAuthorized}<button onClick={ () => domainStore.signOut( () => window.location.reload() ) }>Reload</button></div>
    }

    if(SelectedView) return (<div>
      <SelectedView viewStore={this.viewStore} />
    </div>)

    //actual sign in view    
    return (
      <div className="sign-on-wrapper">
        <div className="input-box sign-on">
          <form data-editable={authContentModel}>
            <div className="role-title">{title}</div>
            <div className="messages">
              {!!headerMessage && <h2 className="header-message">{headerMessage}</h2>}
              {!!welcomeMessage && <div className="welcome-message">{welcomeMessage}</div>}
            </div>
            <div className="inputs">
              <input className="email" type="text" value={claim.loginName} placeholder="Email Address" onChange={e => updateClaim("loginName", e.target.value)} />
              <span className="validation-error">{invalid.email}</span><br />
              <input className="password" type="password" value={claim.password} placeholder="Password" onChange={e => updateClaim("password", e.target.value)} />
              <span className="validation-error">{invalid.password}</span><br />
		          {!!warning && <h2>{warning}</h2>}
              <div className="sign-in-actions">
                <button disabled={Object.keys(invalid).length} className="btn red sign-in-b" onClick={ handleSignIn }>Sign In</button>
              </div>
            </div>
            {!!allowSignupFor && <div className="sign-up-container">
              <span className="nr-text">Not Registered?</span>
              <span className="nr-link" onClick={e => {e.preventDefault(); selectView("signup", {role: allowSignupFor});} }>Sign Up</span>
            </div>}
          </form>
      </div>
    </div>
    )    
  }
}
export default DeloitteSignIn;

@editable
@observer
@autoclass
export class DeloitteSignUp extends BaseComponent{
  render(){
    const {
      contentModel, 
      contentModel: {
        signUpMessage,
        allowSignupFor,
        title
      }, 
      viewStore: {
        handleSignUp, 
        claim, 
        updateClaim, 
        invalidSignUp: invalid,
        clearView
      }
    } = this.props;

    return (
      <div className="sign-on-wrapper">
        <div className="input-box sign-on">
          <form /*data-editable={contentModel}*/>
            {!!contentModel.title && <div className="role-title">{contentModel.title}</div>}
            {!!signUpMessage && <div className="messages">
              {!!signUpMessage && <div className="welcome-message">{signUpMessage}</div>}
            </div>}      
            <div className="inputs">
                <input className="firstName" type="text" value={claim.firstName} placeholder="First Name" onChange={e => updateClaim("firstName", e.target.value)} />
                <span className="validation-error">{invalid.firstName}</span><br />
                <input className="lastName" type="text" value={claim.lastName} placeholder="Last Name" onChange={e => updateClaim("lastName", e.target.value)} />
                <span className="validation-error">{invalid.lastName}</span><br />
              <input className="email" type="text" value={claim.loginName} placeholder="Email Address" onChange={e => updateClaim("loginName", e.target.value)} />
              <span className="validation-error">{invalid.email}</span><br />
              <input className="password" type="password" value={claim.password} placeholder="Password" onChange={e => updateClaim("password", e.target.value)} />
              <span className="validation-error">{invalid.password}</span><br />
              <input className="passwordConfirm" type="password" value={claim.passwordConfirm} placeholder="Confirm Password" onChange={e => updateClaim("passwordConfirm", e.target.value)} />
              <span className="validation-error">{invalid.passwordConfirm}</span><br />


              <select className="demographic1" type="text" value={claim.demographic1} placeholder="Demographic 1" onChange={e => updateClaim("demographic1", e.target.value)} >
                <option value="0">Demographic 1</option>
                <option value="1">Value 1</option>
                <option value="2">Value 2</option>
                <option value="3">Value 3</option>
                <option value="4">Value 4</option>
                <option value="5">Value 5</option>
              </select>
              <select className="demographic2" type="text" value={claim.demographic2} placeholder="Demographic 2" onChange={e => updateClaim("demographic2", e.target.value)} >
                <option value="0">Demographic 2</option>
                <option value="1">Value 1</option>
                <option value="2">Value 2</option>
                <option value="3">Value 3</option>
                <option value="4">Value 4</option>
                <option value="5">Value 5</option>
              </select>
              <select className="demographic3" type="text" value={claim.demographic3} placeholder="Demographic 3" onChange={e => updateClaim("demographic3", e.target.value)} >
                <option value="0">Demographic 3</option>
                <option value="1">Value 1</option>
                <option value="2">Value 2</option>
                <option value="3">Value 3</option>
                <option value="4">Value 4</option>
                <option value="5">Value 5</option>
              </select>
              <select className="demographic4" type="text" value={claim.demographic4} placeholder="Demographic 4" onChange={e => updateClaim("demographic4", e.target.value)} >
                <option value="0">Demographic 4</option>
                <option value="1">Value 1</option>
                <option value="2">Value 2</option>
                <option value="3">Value 3</option>
                <option value="4">Value 4</option>
                <option value="5">Value 5</option>
              </select>
              <select className="demographic5" type="text" value={claim.demographic5} placeholder="Demographic 5" onChange={e => updateClaim("demographic5", e.target.value)} >
                <option value="0">Demographic 5</option>
                <option value="1">Value 1</option>
                <option value="2">Value 2</option>
                <option value="3">Value 3</option>
                <option value="4">Value 4</option>
                <option value="5">Value 5</option>
              </select>

              {/*<input className="auth-code" type="password" value={claim.authCode} placeholder="Authorization Code" onChange={e => updateClaim("authCode", e.target.value)} />*/}
              <div className="sign-in-actions">
                <span className="btn red sign-up-b" disabled={!!Object.keys(invalid).length} onClick={handleSignUp}>Sign Up</span>
              </div>
            </div>
            {!!allowSignupFor && <div className="sign-up-container">
              <span className="nr-text">Already Registered?</span>
              <span className="nr-link" onClick={e => clearView()}>Sign In</span>
            </div>}
          </form>
        </div>
      </div>)
  }
}

@editable
@observer
@autoclass
export class DeloitteChooseSession extends BaseComponent {
  render() {
    const { contentModel, contentModel: { signUpMessage }, handleSignUp, claim, updateClaim, invalid } = this.props;

    return (
      <div className="sign-on-wrapper">
        <div className="input-box sign-on">
          <form data-editable={contentModel}>
            {!!signUpMessage && <div className="messages">
              {!!signUpMessage && <div className="signup-message">{signUpMessage}</div>}
            </div>}
            <div className="inputs">
              <input className="email" type="text" value={claim.loginName} placeholder="Email Address" onChange={e => updateClaim("loginName", e.target.value)} />
              <span className="validation-error">{invalid.email}</span>
              <br />
              <input className="password" type="password" value={claim.password} placeholder="Password" onChange={e => updateClaim("password", e.target.value)} />
              <span className="validation-error">{invalid.password}</span>
              <br />
              <div className="sign-in-actions">
                <span className="btn red sign-up-b" onClick={handleSignUp}>Sign Up</span>
              </div>
            </div>
          </form>
        </div>
      </div>)
  }
}



// WEBPACK FOOTER //
// ./app_modules/deloitte-auth-strategy/component.js